import { axios } from '@/utils/request'

const api = {
  enterpriseGuarantee: '/enterprise/guarantee',
  enterpriseDemand: '/enterprise/demand',
  enterpriseDemandPic: '/enterprise/demandPic'
}

// 获取企业保修期列表
export function getGuaranteeList (parameter) {
  return axios({
    url: api.enterpriseGuarantee + '/list',
    method: 'get',
    params: parameter
  })
}

// 保存企业保修期
export function saveEnterpriseGuarantee (parameter) {
  return axios({
    url: api.enterpriseGuarantee + '/save',
    method: 'post',
    data: parameter,
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    }
  })
}

// 获取企业要求列表
export function getDemandList (parameter) {
  return axios({
    url: api.enterpriseDemand + '/list',
    method: 'get',
    params: parameter
  })
}

// 更新企业要求
export function updateDemand (parameter) {
  return axios({
    url: api.enterpriseDemand + '/update',
    method: 'post',
    data: parameter,
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    }
  })
}

// 新增企业要求
export function addDemand (parameter) {
  return axios({
    url: api.enterpriseDemand + '/add',
    method: 'post',
    data: parameter,
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    }
  })
}

// 禁用企业要求
export function disableDemand (parameter) {
  return axios({
    url: api.enterpriseDemand + '/disable',
    method: 'post',
    params: parameter,
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    }
  })
}

// 启用企业要求
export function enableDemand (parameter) {
  return axios({
    url: api.enterpriseDemand + '/enable',
    method: 'post',
    params: parameter,
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    }
  })
}

// 删除企业要求
export function delDemand (parameter) {
  return axios({
    url: api.enterpriseDemand + '/remove',
    method: 'post',
    params: parameter,
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    }
  })
}

// 查询企业要求关联
export function getDemandRelated (parameter) {
  return axios({
    url: api.enterpriseDemand + '/get/' + parameter,
    method: 'get'
  })
}

// 企业要求关联型号
export function configModels (parameter) {
  return axios({
    url: api.enterpriseDemand + '/configModels',
    method: 'post',
    data: parameter,
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    }
  })
}

// 企业要求关联型号
export function configOrderTypes (parameter) {
  return axios({
    url: api.enterpriseDemand + '/configOrderTypes',
    method: 'post',
    data: parameter,
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    }
  })
}

// 企业要求图片新增
export function demandPicAdd (parameter) {
  return axios({
    url: api.enterpriseDemandPic + '/add',
    method: 'post',
    data: parameter,
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    }
  })
}

// 企业要求图片新增
export function demandPicList (parameter) {
  return axios({
    url: api.enterpriseDemandPic + '/list',
    method: 'get',
    params: parameter
  })
}
